<template>
  <div>
    <b-col class="d-flex align-items-center mb-1" lg="12">
      <div
        class="bg-warning rounded-lg mr-50"
        style="width: 4px; height: 15px; margin-bottom: 5px"
      ></div>
      <h5 class="text-white">messages</h5>
    </b-col>
    <b-card>
      <data-table :fields="fields" :items="messages" :loading="loading">
        <template #id="{ data }">
          <span>
            {{ data.item.id }}
          </span>
        </template>
        <template #key="{ data }">
          <span>
            {{ data.item.key }}
          </span>
        </template>
        <template #name="{ data }">
          <span>
            {{ data.item.name }}
          </span>
        </template>
        <template #actions="{ data }">
          <span>
            <b-button class="small hover-info" @click="clickedit(data.item)"
              >Edit</b-button
            >
          </span>
        </template>
      </data-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="lg"
        pills
        class="my-2 d-flex"
      >
      </b-pagination>
    </b-card>
    <change-message-modal
      v-if="showModal"
      :showChangeMessage="showModal"
      :currentData="MessageEdit"
      @updatePartners="getMessage"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import DataTable from "@/@core/components/data-table/DataTable.vue";
import { BCol, BButton, BRow, BCard, BPagination } from "bootstrap-vue";
import ChangeMessageModal from "./changeMassageModal.vue";
import qs from "qs";

export default {
  components: {
    BPagination,
    DataTable,
    ChangeMessageModal,
    BCol,
    BButton,
    BRow,
    BCard,
  },
  data() {
    return {
      loading: false,
      showModal: false,
      currentPage: 1,
      pagination: {},
      MessageEdit: "",
      messages: [],
      fields: [
        { key: "id", label: "id" },
        { key: "key", label: "key" },
        { key: "name", label: "name" },
        { key: "actions", label: "actions" },
      ],
    };
  },
  watch: {
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "messages",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      async handler(val) {
        await this.getMessage();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    clickedit(data) {
      this.MessageEdit = data;
      this.showModal = true;
    },
    async getMessage() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,

        };
        const { data } = await this.$http.get("/panel/messages/", {
          params, 
        });
        this.messages = data.data;

        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  }
};
</script>
